import { takeLatest } from 'redux-saga/effects';
import SagasHelper from "../../helpers/Redux/SagasHelper";
import { SEO_ACTION } from "./actionTypes";
import { SeoApi } from "./api";
import { SeoActions, SeoStateSelectors } from "./index";
/**
 * Get page meta data
 *
 * @param {object} action
 *
 * @return {IterableIterator<PutEffect<{type, message}>|PutEffect<{countries, type}>|CallEffect|PutEffect<{type}>>}
 */

function* getMeta(action) {
  yield SagasHelper.action(action, SeoApi.getMeta);
}
/**
 * Create model
 *
 * @param {object} action
 *
 * @return {IterableIterator<PutEffect<{type, message}>|PutEffect<{properties, type}>|CallEffect|PutEffect<{type}>>}
 */


function* create(action) {
  yield SagasHelper.defaultAction(action, SeoApi.create);
}
/**
 * View model
 *
 * @param {object} action
 *
 * @return {IterableIterator<PutEffect<{type, message}>|PutEffect<{properties, type}>|CallEffect|PutEffect<{type}>>}
 */


function* view(action) {
  yield SagasHelper.defaultAction(action, SeoApi.view);
}
/**
 * List model
 *
 * @param {object} action
 *
 * @return {IterableIterator<PutEffect<{type, message}>|PutEffect<{properties, type}>|CallEffect|PutEffect<{type}>>}
 */


function* list(action) {
  yield SagasHelper.defaultList(action, SeoApi.list);
}
/**
 * Update model
 *
 * @param {object} action
 *
 * @return {IterableIterator<PutEffect<{type, message}>|PutEffect<{properties, type}>|CallEffect|PutEffect<{type}>>}
 */


function* update(action) {
  yield SagasHelper.defaultAction(action, SeoApi.update);
}
/**
 * Delete property
 *
 * @param {object} action
 *
 * @return {IterableIterator<PutEffect<{type, message}>|PutEffect<{properties, type}>|CallEffect|PutEffect<{type}>>}
 */


function* deleteModel(action) {
  yield SagasHelper.defaultAction(action, SeoApi.delete, null, null, function* (...params) {
    yield SagasHelper.afterDeleteModelFromList(...params, SeoStateSelectors.list, SeoActions.setList);
  });
}

export default [takeLatest(SEO_ACTION.GET_META, getMeta), takeLatest(SEO_ACTION.LIST_META, list), takeLatest(SEO_ACTION.VIEW_META, view), takeLatest(SEO_ACTION.CREATE_META, create), takeLatest(SEO_ACTION.UPDATE_META, update), takeLatest(SEO_ACTION.DELETE_META, deleteModel)];